import { InformationAlertIcon } from "@images/svgIcons/informationAlertIcon"
import { word } from "@modules/core/utils/i18n"
import { useProgramAthleteSubscription } from "@modules/programs/hooks/useProgramSubscription"
import { Program } from "@modules/programs/programTypes"
import { HUButton } from "@modules/ui/components/huButton"
import { HUText } from "@modules/ui/components/huText"
import { useTheme } from "styled-components"

type ProgramBundleDoubleSubscriptionInformationProps = {
  program: Program
}

export const ProgramBundleDoubleSubscriptionInformation: React.FC<ProgramBundleDoubleSubscriptionInformationProps> = ({
  program,
}) => {
  const theme = useTheme()

  const { isUpdating: isUnsubscribing, unsubscribe } = useProgramAthleteSubscription(program)

  return (
    <div className="card banner rounded-33 overflow-hidden p-1">
      <div className="flex flex-row justify-content-between align-items-start gap-4 p-4 flex-grow-1">
        <div className="flex justify-content-between align-items-center p-0 bg-primary-500 rounded-33 ">
          <InformationAlertIcon color={theme.mainBlack} backgroundColor={theme.primaryColor500} />
        </div>

        <div className="flex flex-column gap-4">
          <HUText fontStyle="BL">
            {word("program.subscription.doubleSubscription.title", {
              programBundleName: program.programBundle?.programBundleName,
            })}
          </HUText>

          <HUButton
            type="Default"
            colorType="Primary"
            size="S"
            className="px-4 py-2"
            text={word("program.subscription.doubleSubscription.unsubscribeSingleProgram")}
            onClick={unsubscribe}
            loading={isUnsubscribing}
            disabled={isUnsubscribing}
          />
        </div>
      </div>
    </div>
  )
}
